<div>
    <rask-header size="4" noPadding>Rask knapp (showroom-rask-button)</rask-header>
    <p>
        <strong>color</strong> Styr vilket utseende knappen ska ha. (primary, secondary, tertiary). Default är
        primary.<br>
        <strong>negative</strong> Flagga för att ge knappen ett negativt utseende<br>
        <strong>disabled</strong> Flagga för att bestämma om knappen är aktiv eller inte<br>
        <strong>icon</strong> Om knappen ska en ikon, sätts ikon-klassen här<br>
        <strong>type</strong> Default 'button'<br>
        <strong>form?</strong> Bind mot formulärs submithandler, om type är 'submit'<br>

    </p>
    <div class="row">
        <div class="col">
            <div class="row mb-2">
                <div class="col">
                    <rask-button color="primary">Primary</rask-button>
                </div>
                <div class="col">
                    <rask-button color="primary" icon="fal fa-save">Primary w Icon</rask-button>
                </div>
                <div class="col">
                    <rask-button color="primary" negative>Primary Negative</rask-button>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col">
                    <rask-button color="primary" disabled>Primary</rask-button>
                </div>
                <div class="col">
                    <rask-button color="primary" icon="fal fa-save" disabled>Primary w Icon</rask-button>
                </div>
                <div class="col">
                    <rask-button color="primary" negative disabled>Primary Negative</rask-button>
                </div>
            </div>
            <div class="row mb-2 mt-5">
                <div class="col">
                    <rask-button color="secondary">Secondary</rask-button>
                </div>
                <div class="col">
                    <rask-button color="secondary" icon="fal fa-save">Secondary w Icon</rask-button>
                </div>
                <div class="col">
                    <rask-button color="secondary" negative>Secondary Negative</rask-button>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col">
                    <rask-button color="secondary" disabled>Secondary</rask-button>
                </div>
                <div class="col">
                    <rask-button color="secondary" icon="fal fa-save" disabled>Secondary w Icon</rask-button>
                </div>
                <div class="col">
                    <rask-button color="secondary" negative disabled>Secondary Negative</rask-button>
                </div>
            </div>
            <div class="row mb-2 mt-5">
                <div class="col">
                    <rask-button color="tertiary">Tertiary</rask-button>
                </div>
                <div class="col">
                    <rask-button color="tertiary" icon="fal fa-save">Tertiary w Icon</rask-button>
                </div>
                <div class="col">
                    <rask-button color="tertiary" negative>Tertiary Negative</rask-button>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col">
                    <rask-button color="tertiary" disabled>Tertiary</rask-button>
                </div>
                <div class="col">
                    <rask-button color="tertiary" icon="fal fa-save" disabled>Tertiary w Icon</rask-button>
                </div>
                <div class="col">
                    <rask-button color="tertiary" negative disabled>Tertiary Negative</rask-button>
                </div>
            </div>
        </div>
    </div>

</div>